'use client';

import React from 'react';

const CallToActionForm = React.lazy(() =>
  import('@benzinga/forms-ui').then(module => ({
    default: module.CallToActionForm,
  })),
);

export function PremarketNewsletter() {
  return (
    <React.Suspense fallback={<div className="h-[328px]" />}>
      <CallToActionForm
        beehiivFormId="c03f46e3-b180-439f-8cf4-103cbf2ac567"
        styleOption="secondary"
        subtitle="The 5-minute newsletter with brief insights on big investment opportunities."
        title="Beat The Market With Premarket News and Trade Signals"
      />
    </React.Suspense>
  );
}
